import React, { useState, useEffect, Fragment } from 'react';
import { Asset } from '@archetypes'
import { Button, Table, Panel, LazyBoi, GateKeeper, Placeholder } from '@components'
import { formatTimestamp, fromWei, fromWeiToNumber } from '@util/helpers'
import appController, { Status } from '@app/App.Controller'
import { ReactComponent as IconGear } from '@assets/Icon_Gear.svg';
import { ReactComponent as IconRefresh } from '@assets/Icon_Refresh.svg';
import { ReactComponent as IconPoolsEmpty2 } from '@assets/Icon_PoolsEmpty2.svg';
import styled from "styled-components"


const columns = [
	{
		Header: 'Token',
		accessor: 'token',
	},
	{
		Header: 'Your Debt',
		accessor: 'debt',
	},
	{
		Header: "Your Collateral",
		accessor: "collateral"
	},
	{
		Header: "Collateral Ratio",
		accessor: "collateralRatio"
	},
	{
		Header: '',
		accessor: 'actions',
	}
]

const TableRow = ({ address, symbol, cr_current, cr_global, cr_minimum, expiry, safe }) => <Table.Uncontrolled.Row
	key={address}
	fields={{
		token: <Asset.Icon token={[symbol]} />,
		cr_current: <LazyBoi value={cr_current} dp={2} />,
		cr_global: <LazyBoi value={cr_global} dp={2} />,
		// cr_minimum: <LazyBoi value={cr_minimum}  dp={2} fromWei />,
		expiry: <LazyBoi value={formatTimestamp(expiry)} />,
		status: <Asset.Position.Tag safe={safe} />,
		actions: <Button small icon={<IconGear />} to={`/assets/${address}`}>Manage</Button>,
	}}
/>

const Entry = styled(
	({ className, symbol, amount, logo, expiry }) => {
		return (
			<div className={className}>
				{logo ?
					<>
						<Asset.Icon.Large showText={false} token={[symbol]} />
						<div className="body" style={{ display: "flex", flexDirection: "column", marginLeft: 15 }}>
							<h2>{symbol}</h2>
							<p>Expires {formatTimestamp(expiry)}</p>
						</div>
					</>
					:
					<div className="body" style={{ display: "flex", flexDirection: "column" }}>
						<h4>{fromWeiToNumber(amount, 2)}</h4>
						<p>{symbol}</p>
					</div>}
			</div>
		)
	})`

		h4, h2, p {
			margin : 0px;
			font-weight: 600;
		}

		h2 {
			font-weight: 700;
			font-size: 16px;
			line-height: 24px;
		}

		h4 {
			font-size: 16px;
			color: var(--color-white);
			line-height: 24px;
		}

		p {
			font-size: 12px;
			color: var(--color-label, lightblue);
			line-height: 16px;
		}

	`



const PositionRowV3 = (position) => {
	const { accessor, columnIndex, collateralAmount, collateralSymbol, address, expiry } = position

	let component
	switch (accessor) {
		case "token":
			component = (<Entry logo={true} symbol={position?.symbol} expiry={expiry} />)
			break
		case "debt":
			component = (<Entry symbol={position?.symbol} amount={position?.debtAmount} expiry={expiry} />)
			break
		case "collateral":
			component = (<Entry symbol={position?.collateralSymbol} amount={position?.collateralAmount} expiry={expiry} />)
			break
		case "collateralRatio":
			component = (<Asset.CollateralRatio position={position} />)
			break
		case "actions":
			component = (
				<div style={{ marginLeft: "20px" }}>
					<Button small to={`/mint/${address}`}>Manage</Button>
				</div>
			)
			break
		default:
			component = ""
	}
	return <div key={columnIndex}>{component}</div>
}


export default () => {
	const { synthetics } = appController
	const [positions, setPositions] = useState([])

	useEffect(() => {
		const sub = synthetics.state.subscribe('emps', emps => {
			const empItems = Object.values(emps)
			if (empItems.length > 0) {
				let myPositions = empItems.map(emp => {

					const expired = new Date().valueOf() > (Number(emp?.expirationTimestamp) * 1000)

					return +emp?.myPosition?.collateral > 0
						? {
							address: emp?.address,
							symbol: emp?.token1?.symbol,
							cr_current: emp?.myPosition?.actualCurrentRatio,
							cr_global: emp?.actualGCR,
							// cr_minimum: emp?.globalCollateralisationRatio,
							cr_minimum: emp?.myPosition?.requiredRatio,
							expiry: emp?.expirationTimestamp,
							expired: expired,
							safe: emp?.myPosition?.safe,
							debtAmount: emp?.myPosition?.tokensOutstanding,
							collateralAmount: emp?.myPosition?.collateral,
							collateralSymbol: emp?.token0?.symbol
						}
						: false
				}).filter(o => o)

				setPositions(myPositions)
			}
		}, true)
		return () => sub.unsubscribe()
	}, []) // eslint-disable-line



	return (
		<GateKeeper
			controllerAssertions={[
				{
					controller: 'account',
					key: 'status',
					assert: val => val === Status.READY,
					onFail: <Panel fadeIn>Connect your wallet to view your asset CDPs</Panel>,
				},
				{
					controller: 'perlinx',
					key: 'status',
					assert: val => val === Status.READY,
					onFail: <Panel fadeIn><Fragment><IconRefresh className='rotate' />Fetching assets</Fragment></Panel>,
				},
			]}
			assertions={[
				{
					assert: () => Array.isArray(positions) && !!positions.length,
					onFail: () => <Panel fadeIn><Placeholder
						icon={<IconPoolsEmpty2 style={{ marginLeft: '0.3em' }} />}
						title='No positions created '
						text='Mint a synthetic assets to create a position.'
						links={[
							{
								to: '/assets',
								text: 'View Available Assets'
							}
						]}
					/></Panel>
				}
			]}
			dependencies={[positions]}
		>
			{/* <Table.Uncontrolled columns={columns}>
				{positions.map((position, i) => <TableRow key={i} {...position}/>)}
				</Table.Uncontrolled> 
			*/}
			<Table.V3
				columns={columns}
				rows={positions && positions.map((position, positionIndex) => <div key={positionIndex}>{columns.map(({ accessor }, columnIndex) => <PositionRowV3 accessor={accessor} columnIndex={columnIndex} {...position} />)}</div>)}
			// rows={positions && positions.map((position, positionIndex) => <div key={positionIndex}>{columns.map(({ accessor }, columnIndex) => <div style={{display :"flex", flexDirection :"column", flexGrow : 1, backgroundColor : "blue"}}><p style={{backgroundColor :"red", margin: 0}}>hello</p><p style={{backgroundColor :"yellow", margin: 0}}>hello</p></div>)}</div>)}
			/>

		</GateKeeper>
	)
}